var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0825 6.7602L7.76698 11.1423L5.91746 9.26428M9 0.5L11.0664 3.49927L14.548 2.55045L14.2323 6.19678L17.5 7.74237L14.95 10.3296L16.4748 13.6464L12.8836 13.964L11.952 17.5L9 15.3993L6.04798 17.5L5.11641 13.964L1.52523 13.6464L3.05 10.3296L0.5 7.74237L3.76766 6.19678L3.45202 2.55045L6.93359 3.49927L9 0.5Z",
    stroke: "#1D8B39",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/activeIcon.f642fea2ad19fedf9399b9e591ac9dd1.svg";
export { ForwardRef as ReactComponent };